import { render, staticRenderFns } from "./stagingEnvLabel.vue?vue&type=template&id=0112e8fd&scoped=true"
import script from "./stagingEnvLabel.vue?vue&type=script&lang=js"
export * from "./stagingEnvLabel.vue?vue&type=script&lang=js"
import style0 from "./stagingEnvLabel.vue?vue&type=style&index=0&id=0112e8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112e8fd",
  null
  
)

export default component.exports